import React from "react";
import StatBox from "./StatBox";
import "./StatsCards.css";

function StatsCards({ config = [], totals = {}, loading, formatter }) {
  return (
    <div className="stats-cards-container">
      {config.map((item) => (
        <StatBox
          key={item.key}
          icon={item.icon}
          title={item.title}
          value={formatter ? formatter(totals[item.key]) : totals[item.key]}
          loading={loading}
        />
      ))}
    </div>
  );
}

export default StatsCards;
